import styled from 'styled-components';

const RichTextQuote = styled.div`
  border-left: 8px solid var(--blue-3);
  padding-left: 20px;
  margin-top: 10px;

  p {
    font-style: italic;
  }
`;

export default RichTextQuote;
